import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteContentModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteContentModalContainer" */
      './DeleteContentModalContainer'
    ),
  loading: LoadingModal,
});
